// AllDropdowns.js
import React from "react";
import EventDetails from "./EventDetails";
import FollowUpTasks from "./FollowUpTasks";
import InteractionNotes from "./InteractionNotes";
import OpportunityStage from "./OpportunityStage";
import CallDetails from "./CallDetails";
import Invoices from "./Invoices";
import "./Dropdowns.css";
import { useSelector } from "react-redux";

const AllDropdowns = () => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin";
  const { selectedConvo } = useSelector((state) => state.messages);
  return (
    <div className="wc-chat-drops">
      <EventDetails />
      <FollowUpTasks />
      {selectedConvo?.postType == 3 &&
        (selectedConvo?.createdBy == user?.UserID || isAdmin) && (
          <InteractionNotes />
        )}
      <OpportunityStage />
      <CallDetails />
      <Invoices />
    </div>
  );
};

export default AllDropdowns;
